import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-modal-instructions',
  templateUrl: './modal-instructions.component.html',
  styleUrls: ['./modal-instructions.component.scss'],
})
export class ModalInstructionsComponent implements OnInit {

  @Input() title?: string;
  @Input() steps?: string;
  constructor(private modal: ModalController) { }

  ngOnInit() {}

  async onButtonClick(evt: any) {
    return this.modal.dismiss({
      value: evt
    });
  }
}
